import Menu from '../components/general/Menu';
import Footer from '../components/general/Footer';
import { Container } from 'react-bootstrap'
import Randomizer from "components/ContestRandomizer/Randomizer"

export default function ContestRandomizer() {

  // console.log(meeting.length)

  return (
    <section className='home'>
      <Menu />
      <Container>
        <Randomizer />
      </Container>
      <Footer />
    </section >
  )
}